import * as Sentry from "@sentry/browser";
import { LoaderError } from "@dpdgroupuk/mydpd-ui";
import { compose, withHandlers } from "recompose";

export default compose(
  withHandlers({
    onLoadFailure: () => error => {
      if (error.statusCode && error.statusCode >= 500) {
        return Sentry.captureException(error);
      }
      throw new LoaderError(error);
    },
  })
);
